export enum EEuDdpOrderShippingStatusCode {
	UNFULFILLED = 'unfulfilled',
	S_REQUESTED = 's_requested',
	S10_EXPECTED = 's10_expected',
	PAYMENT_EXPECTED = 'payment_expected',
	WAITING_PROFORMA = 'waiting_proforma',
	PROFORMA_SIGNED = 'proforma_signed',
	L_GENERATED = 'l_generated',
	RM_RECIEVED = 'rm_recieved',
	OMNIVA_RECIEVED = 'omniva_recieved',
	CUSTOMS_START = 'customs_start',
	CLEARED = 'cleared',
	OMNIVA_PRINTED = 'omniva_printed',
	OMNIVA_DELIVERED = 'omniva_delivered',
}

export enum EEuDdpOrderShippingStatusName {
	UNFULFILLED = 'Unfulfilled',
	S_REQUESTED = 'Shipment Requested',
	S10_EXPECTED = 'Awaiting S10 number',
	PAYMENT_EXPECTED = 'Awaiting payment',
	WAITING_PROFORMA = 'Awaiting Signing',
	PROFORMA_SIGNED = 'Shipment accepted',
	L_GENERATED = 'Label Printed',
	RM_RECIEVED = 'Received by Royal Mail',
	OMNIVA_RECIEVED = 'Delivered to EU warehouse',
	CUSTOMS_START = 'Handling by Customs started',
	CLEARED = 'Released by Customs',
	OMNIVA_PRINTED = 'Delivery to end customer accepted',
	OMNIVA_DELIVERED = 'Delivered to end customer',
}

export enum EEuDdpOrderShippingStatusId {
	UNFULFILLED = 1,
	S_REQUESTED = 2,
	S10_EXPECTED = 13,
	PAYMENT_EXPECTED = 9,
	WAITING_PROFORMA = 6,
	PROFORMA_SIGNED = 3,
	L_GENERATED = 5,
	RM_RECIEVED = 10,
	OMNIVA_RECIEVED = 11,
	CUSTOMS_START = 7,
	CLEARED = 4,
	OMNIVA_PRINTED = 8,
	OMNIVA_DELIVERED = 12,
}
